/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Provider } from "../generated/graphql";
import { Maybe } from "./types";

export type Typename =
  | "Account"
  | "Application"
  | "CloudResource"
  | "CostResource"
  | "Environment"
  | "OrgUnitV2";

export function isCloudResource<
  T extends Maybe<{
    __typename?: Typename;
  }>
>(resource: T): resource is T & { __typename: "CloudResource" } {
  return resource?.__typename === "CloudResource";
}

export function isCostResource<
  T extends Maybe<{
    __typename?: Typename;
  }>
>(resource: T): resource is T & { __typename: "CostResource" } {
  return resource?.__typename === "CostResource";
}

export function isCloudResourceWithExternalProvider<
  T extends {
    __typename?: Typename;
    provider?: Provider;
  }
>(
  entity: T
): entity is T & { __typename: "CloudResource"; provider: Provider.External } {
  return isCloudResource(entity) && entity.provider === Provider.External;
}

export function isString(value: unknown): value is string {
  return typeof value === "string";
}

export function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && !Array.isArray(value) && value !== null;
}
